<template>
  <div>
    <el-card class="box-card">
      <div>
        <el-card class="form-card">
          <el-form ref="form"
                   v-model="form"
                   :inline="true"
                   class="demo-form-inline"
                   label-width="110px">
            <el-row>

              <el-form-item label="平台"
                            prop="platCode">
                <el-select v-model="form.platCode"
                           placeholder="请选择平台">
                  <el-option v-for="item in PlatLists"
                             :key="item.id"
                             :label="item.platName"
                             :value="item.platCode"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="店铺名称">
                <el-input v-model="form.shopName"></el-input>
              </el-form-item>

              <el-form-item label="店铺编号">
                <el-input v-model="form.shopCode"></el-input>
              </el-form-item>

              <el-form-item label="商家">
                <el-select v-model="form.ptnCode"
                           placeholder="请选择商家">
                  <el-option v-for="item in PartnerLists"
                             :key="item.id"
                             :label="item.ptnName"
                             :value="item.ptnCode"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="启用状态">
                <el-select v-model="form.actFlag">
                  <el-option label="不限"
                             value></el-option>
                  <el-option label="启用"
                             value="T"></el-option>
                  <el-option label="禁用"
                             value="F"></el-option>
                </el-select>
              </el-form-item>

            </el-row>
            <el-row>

              <el-form-item label=" ">
                <el-button @click="dialogFormVisible = true">新增</el-button>
                <el-button type="primary"
                           @click="onSubmit">搜索</el-button>
              </el-form-item>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-card>

    <el-table :data="ShopList"
              v-loading="loading"
              :show-overflow-tooltip="true"
              border
              stripe
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%"
              height="500">
      <el-table-column type="index"
                       align="center"
                       label="#"></el-table-column>
      <el-table-column prop="shopName"
                       label="店铺"
                       show-overflow-tooltip
                       min-width="120px"></el-table-column>
      <el-table-column prop="shopCode"
                       label="店铺编号"
                       min-width="80px"></el-table-column>
      <el-table-column prop="platCode"
                       label="平台编号"
                       width="80px"></el-table-column>
      <el-table-column prop="ptnCode"
                       label="商家编号"
                       min-width="80px"></el-table-column>
      <el-table-column prop="shopOwner"
                       label="负责人"
                       show-overflow-tooltip
                       min-width="100px"></el-table-column>
      <el-table-column prop="ownerTel"
                       label="联系电话"
                       show-overflow-tooltip
                       min-width="100px"></el-table-column>
      <el-table-column prop="ownerEmail"
                       label="邮箱"
                       show-overflow-tooltip
                       min-width="100px"></el-table-column>
      <!-- <el-table-column prop="tokenInvalid" label="有效期" show-overflow-tooltip min-width="100px"></el-table-column> -->
      <!-- <el-table-column prop="tokenInvalid" label="安全库存" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.safetyType=='1'?'固定数量:':(scope.row.safetyType=='2'?'比例%:':'未设置:')}} {{ scope.row.safetyStock }}</template>
      </el-table-column> -->

      <el-table-column prop="actFlag"
                       label="状态"
                       align="center"
                       width="90px">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.actFlag"
                     active-color="#13ce66"
                     inactive-color="#ff4949"
                     active-value="T"
                     inactive-value="F"
                     @change="chageAct(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       min-width="80px">
        <template slot-scope="scope">
          <!-- 编辑 -->
          <el-tooltip effect="dark"
                      content="编辑"
                      placement="top"
                      :enterable="false">
            <el-button type="primary"
                       icon="el-icon-edit"
                       size="mini"
                       @click="showEditDilog(scope.row)"></el-button>
          </el-tooltip>

          <!-- 删除 -->
          <el-tooltip effect="dark"
                      content="删除"
                      placement="top"
                      :enterable="false">
            <el-button type="danger"
                       icon="el-icon-delete"
                       size="mini"
                       @click="delShop(scope.row.id)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="queryInfo.pagesize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total"></el-pagination>
    </div>

    <el-dialog title="新增店铺"
               :visible.sync="dialogFormVisible"
               width="600px"
               @close="addDilogClosed"
               :close-on-click-modal="false">
      <el-form :model="addform"
               ref="addformRef"
               :rules="rulesAdd">
        <el-form-item label="店铺名称"
                      prop="shopName"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.shopName"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="店铺编号"
                      prop="shopCode"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.shopCode"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="平台"
                      prop="platCode"
                      :label-width="formLabelWidth">
          <el-select v-model="addform.platCode"
                     placeholder="请选择平台"
                     style="width:80%">
            <el-option v-for="item in PlatLists"
                       :key="item.id"
                       :label="item.platName"
                       :value="item.platCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家"
                      prop="ptnCode"
                      :label-width="formLabelWidth">
          <el-select v-model="addform.ptnCode"
                     placeholder="请选择商家"
                     style="width:80%">
            <el-option v-for="item in PartnerLists"
                       :key="item.id"
                       :label="item.ptnName"
                       :value="item.ptnCode"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="token" prop="token" :label-width="formLabelWidth">
          <el-input v-model="addform.token" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>-->
        <!-- <el-form-item label="到期时间" prop="tokenInvalid" :label-width="formLabelWidth">
          <template>
            <div class="block">
              <el-date-picker v-model="addform.tokenInvalid" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
            </div>
          </template>
        </el-form-item>-->
        <el-form-item label="负责人"
                      prop="shopOwner"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.shopOwner"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="联系电话"
                      prop="ownerTel"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.ownerTel"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="邮箱"
                      prop="ownerEmail"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.ownerEmail"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>

        <!-- <el-form-item label="自动审单" prop="autoCheck" :label-width="formLabelWidth">
          <el-radio-group v-model="addform.autoCheck">
            <el-radio label="T">开启</el-radio>
            <el-radio label="F">关闭</el-radio>
          </el-radio-group>
        </el-form-item>-->

        <!-- <el-form-item label="优先同仓发货" prop="isTogether" :label-width="formLabelWidth">
          <el-radio-group v-model="addform.isTogether">
            <el-radio label="T">是</el-radio>
            <el-radio label="F">否</el-radio>
          </el-radio-group>
        </el-form-item>-->

        <el-form-item label="激活状态"
                      prop="actFlag"
                      :label-width="formLabelWidth">
          <el-radio-group v-model="addform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="店铺类型" prop="shopType" :label-width="formLabelWidth">
          <el-select v-model="addform.shopType" placeholder="请选择类型" style="width:50%">
            <el-option v-for="types in shopType" :key="types.value" :label="types.label" :value="types.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="安全库存" prop="actFlag" :label-width="formLabelWidth">
          <el-input placeholder="请输入数量/比例" v-model="addform.safetyStock" class="input-with-select" style="width:50%">
            <el-select v-model="addform.safetyType" slot="prepend" placeholder="请选择" style="width:120px">
              <el-option v-for="types in safetyType" :key="types.value" :label="types.label" :value="types.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>-->

        <el-form-item label="备注"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.memo"
                    autocomplete="on"
                    style="width:80%"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="addShop">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑店铺"
               :visible.sync="editdialogFormVisible"
               width="600px"
               @close="editDilogClosed"
               :close-on-click-modal="false">
      <el-form :model="editform"
               ref="editformRef"
               :rules="rules"
               size="mini">
        <el-form-item label="店铺名称"
                      prop="shopName"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.shopName"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="店铺编号"
                      prop="shopCode"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.shopCode"
                    disabled
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="平台"
                      prop="platCode"
                      :label-width="formLabelWidth">
          <el-select v-model="editform.platCode"
                     placeholder="请选择平台"
                     style="width:80%">
            <el-option v-for="item in PlatLists"
                       :key="item.id"
                       :label="item.platName"
                       :value="item.platCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商家"
                      prop="ptnCode"
                      :label-width="formLabelWidth">
          <el-select v-model="editform.ptnCode"
                     placeholder="请选择商家"
                     style="width:80%">
            <el-option v-for="item in PartnerLists"
                       :key="item.id"
                       :label="item.ptnName"
                       :value="item.ptnCode"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="token" prop="token" :label-width="formLabelWidth">
          <el-input v-model="editform.token" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="到期时间" prop="tokenInvalid" :label-width="formLabelWidth">
          <template>
            <div class="block">
              <el-date-picker v-model="editform.tokenInvalid" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </div>
          </template>
        </el-form-item>-->
        <el-form-item label="负责人"
                      prop="shopOwner"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.shopOwner"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="联系电话"
                      prop="ownerTel"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.ownerTel"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="邮箱"
                      prop="ownerEmail"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.ownerEmail"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="激活状态"
                      prop="actFlag"
                      :label-width="formLabelWidth">
          <el-radio-group v-model="editform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="店铺类型" prop="shopType" :label-width="formLabelWidth">
          <el-select v-model="editform.shopType" placeholder="请选择类型" style="width:50%">
            <el-option v-for="types in shopType" :key="types.value" :label="types.label" :value="types.value"></el-option>
          </el-select>
        </el-form-item>-->
        <!-- 
        <el-form-item label="自动审单" prop="autoCheck" :label-width="formLabelWidth">
          <el-radio-group v-model="editform.autoCheck">
            <el-radio label="T">开启</el-radio>
            <el-radio label="F">关闭</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="优先同仓发货" prop="isTogether" :label-width="formLabelWidth">
          <el-radio-group v-model="editform.isTogether">
            <el-radio label="T">是</el-radio>
            <el-radio label="F">否</el-radio>
          </el-radio-group>
        </el-form-item>-->

        <!-- <el-form-item label="安全库存" prop="actFlag" :label-width="formLabelWidth">
          <el-input placeholder="请输入数量/比例" v-model="editform.safetyStock" class="input-with-select" style="width:50%">
            <el-select v-model="editform.safetyType" slot="prepend" placeholder="请选择" style="width:120px">
              <el-option v-for="types in safetyType" :key="types.value" :label="types.label" :value="types.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>-->

        <el-form-item label="备注"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.memo"
                    autocomplete="on"
                    style="width:80%"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    max-length="32"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:center">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="saveShop">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    // 验证邮箱规则
    var checkEmail = (rule, value, callback) => {
      // 正则表达式
      const regEmail = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z_-])+/
      if (regEmail.test(value)) {
        return callback()
      }
      callback(new Error('请输入合法的邮箱'))
    }
    // 验证手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^(13[0-9]|15[012356789]|15[012356789]|17[15678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/
      // 符合规则
      if (regMobile.test(value)) {
        return callback()
      }
      callback(new Error('请输入合法的手机号'))
    }

    // token 验证
    var validToken = (rule, value, callback) => {
      if (this.editform.token === null || this.addform.token === '') {
        return callback()
      }

      // 符合规则
      if (value === null) {
        callback(new Error('请输入到期时间'))
      }
      return callback()
    }

    var validTokenAdd = (rule, value, callback) => {
      console.log(this.addform.token)
      if (this.addform.token === null || this.addform.token === '') {
        return callback()
      }

      // 符合规则
      if (!value) {
        callback(new Error('请输入到期时间'))
      }
      return callback()
    }

    return {
      form: {
        shopName: '',
        platCode: '',
        ptnCode: '',
        shopCode: '',
        actFlag: '',
      },
      addform: {
        shopName: '',
        platCode: '',
        ptnCode: '',
        shopCode: '',
        shopOwner: '',
        ownerTel: '',
        ownerEmail: '',
        ptnCode: '',
        shopType: '',
        token: '',
        tokenInvalid: '',
        actFlag: 'T',
        memo: '',
        autoCheck: 'T',
        isTogether: 'T',
      },
      editform: {
        shopName: '',
        platCode: '',
        ptnCode: '',
        shopCode: '',
        shopOwner: '',
        ownerTel: '',
        ownerEmail: '',
        ptnCode: '',
        shopType: '',
        token: '',
        tokenInvalid: '',
        actFlag: '',
        memo: '',
        safetyStock: '',
        safetyType: '',
        autoCheck: '',
        isTogether: '',
      },
      shopType: [
        { value: '10', label: '普通模式' },
        { value: '11', label: '唯品会JIT' },
        { value: '12', label: '唯品会JITX' },
        { value: '13', label: '考拉直发' },
        { value: '14', label: '唯品会MP' },
      ],
      safetyType: [
        { value: '0', label: '不设置' },
        { value: '2', label: '按比例' },
        { value: '1', label: '固定数量' },
      ],
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,
      total: 0,
      selvalue: '',
      dialogFormVisible: false,
      editdialogFormVisible: false,
      formLabelWidth: '100px',
      rules: {
        shopName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        platCode: [
          { required: true, message: '请选择平台编号', trigger: 'change' },
        ],
        ptnCode: [
          { required: true, message: '请选择商家编号', trigger: 'change' },
        ],
        shopCode: [
          { required: true, message: '请输入店铺编号', trigger: 'blur' },
        ],
        // shopOwner: [
        //   { required: true, message: "请输入店铺负责人", trigger: "blur" },
        //   {
        //     min: 2,
        //     max: 32,
        //     message: "长度在 2 到 20 个字符",
        //     trigger: "blur",
        //   },
        // ],
        // ownerTel: [
        //   { required: true, message: "请输入联系电话", trigger: "blur" },
        //   { validator: checkMobile, trigger: "blur" },
        // ],
        // ownerEmail: [
        //   { required: true, message: "请输入负责人邮箱", trigger: "blur" },
        //   { validator: checkEmail, trigger: "blur" },
        // ],

        // tokenInvalid: [{ validator: validToken }],
      },
      rulesAdd: {
        shopName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        platCode: [
          { required: true, message: '请选择平台编号', trigger: 'change' },
        ],
        ptnCode: [
          { required: true, message: '请选择商家编号', trigger: 'change' },
        ],
        shopCode: [
          { required: true, message: '请输入店铺编号', trigger: 'blur' },
        ],
        // shopOwner: [
        //   { required: true, message: "请输入店铺负责人", trigger: "blur" },
        //   {
        //     min: 2,
        //     max: 32,
        //     message: "长度在 2 到 20 个字符",
        //     trigger: "blur",
        //   },
        // ],
        // ownerTel: [
        //   { required: true, message: "请输入联系电话", trigger: "blur" },
        //   { validator: checkMobile, trigger: "blur" },
        // ],
        // ownerEmail: [
        //   { required: true, message: "请输入负责人邮箱", trigger: "blur" },
        //   { validator: checkEmail, trigger: "blur" },
        // ],
        // shopType: [
        //   { required: true, message: "请选择类型", trigger: "change" },
        // ],
        // tokenInvalid: [{ validator: validTokenAdd }],
      },
      // 店铺列表
      ShopList: [],
      // 商家列表
      PartnerLists: [],
      // 平台列表
      PlatLists: [],
      errmsg: '',
      loading: true,
    }
  },
  methods: {
    // 搜索
    onSubmit() {
      this.queryInfo.pagenum = 1
      this.currentPage = 1
      this.queryInfo.query = this.form
      this.getShopLists()
    },

    handleSizeChange(val) {
      this.queryInfo.pagesize = val

      this.getShopLists()
    },

    handleCurrentChange(val) {
      this.queryInfo.pagenum = val

      this.getShopLists()
    },

    // 关闭新增窗口
    addDilogClosed() {
      this.$refs.addformRef.resetFields()
    },
    editDilogClosed() {
      this.$refs.editformRef.resetFields()
    },
    // 新增店铺
    async addShop() {
      // debugger
      // this.$refs.addformRef.validate(async (valid) => {
      //   if (!valid) return;

      await this.$http
        .post('addshop', this.addform)
        .then((response) => {
          const res = response.data

          this.$message.success('添加店铺成功')

          this.dialogFormVisible = false

          this.getShopLists()
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
      // });
    },
    // 显示修改对话框
    async showEditDilog(row) {
      let copy = Object.assign({}, row)
      this.editform = copy
      this.editdialogFormVisible = true
    },
    // 保存编辑店铺信息
    saveShop() {
      // this.$refs.editformRef.validate(async (valid) => {
      //   if (!valid) return;

      this.$http
        .post('editshop', this.editform)
        .then((response) => {
          const res = response.data

          this.$message.success('编辑店铺成功')
          this.editdialogFormVisible = false
          this.getShopLists()
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
      // });
    },
    // 删除店铺
    async delShop(shopid) {
      // 弹框询问是否删除
      const confirmResult = await this.$confirm(
        '此操作将永久删除该店铺, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)

      // 确认删除
      if (confirmResult == 'confirm') {
        const { data: res } = await this.$http
          .delete('delshop/' + shopid)
          .then((response) => {
            const res = response.data

            this.getShopLists()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      }
    },
    // 变更激活状态
    async chageAct(ShopInfo) {
      await this.$http
        .put('actshop/' + ShopInfo.id + '/' + ShopInfo.actFlag)
        .then((response) => {
          const res = response.data

          this.$message.success(res.data)
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },
    // 获取店铺列表
    async getShopLists() {
      this.loading = true
      await this.$http
        .post('shoplists', this.queryInfo)
        .then((response) => {
          const res = response.data

          this.ShopList = res.data.data

          this.total = res.data.total
          this.loading = false
          this.currentPage = res.data.current_page
        })
        .catch((error) => {
          this.loading = false
          return this.$message.error(error.response.data.message)
        })
    },
    // 获取商家列表
    async getPartnerLists() {
      await this.$http
        .post('ptnlists', {
          query: '',
          pagenum: 1,
          pagesize: 100,
        })
        .then((response) => {
          const res = response.data
          this.PartnerLists = res.data.data
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },
    // 获取平台列表
    async getPlatLists() {
      await this.$http
        .post('platlists', {
          query: '',
          pagenum: 1,
          pagesize: 100,
        })
        .then((response) => {
          const res = response.data
          this.PlatLists = res.data.data
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },
  },
  created() {
    this.getShopLists()
    this.getPartnerLists()
    this.getPlatLists()
  },
}
</script>

<style lang="less" scoped>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.add-card {
  width: 50%;
}
.el-dialog {
  /* 表单页面居中，宽度50% ,legend颜色设置，legend圆角*/
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/basic/shop.vue